export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";